import React from 'react';
import {Box, Stack, Typography} from '@mui/material';
import SCNumberField from './SCNumberField.js';
import { useMemo } from 'react';
import { useCallback } from 'react';

const SCTimePicker = props=>{
    let {value, onChange, label} = props;
    let hours = useMemo(()=>value.getHours(), [value]);
    let minutes = useMemo(()=>value.getMinutes(), [value]);
    let setHours = useCallback(v=>{
        let res = new Date(value);
        res.setHours(v);
        onChange(res);
    }, [value, onChange]);
    let setMinutes = useCallback(v=>{
        let res = new Date(value);
        res.setMinutes(v);
        onChange(res);
    }, [value, onChange]);
    return <Stack direction="column" gap={1}>
      {label&&<Typography color="text.secondary">
        {label}
      </Typography>}
      <Stack direction="row" alignItems="center" gap="2px">
        <Box width="80px">
          <SCNumberField
            min={0}
            max={60}
            size="small"
            value={minutes}
            onChange={setMinutes}
          />
        </Box>
        <Typography>:</Typography>
        <Box width="80px">
          <SCNumberField
            min={0}
            max={24}
            size="small"
            value={hours}
            onChange={setHours}
          />
        </Box>
      </Stack>
    </Stack>;
};

export default SCTimePicker;
